// Centralized build/version info for display in the UI
// Prefer explicit env var, else fall back to client package.json version, else 'dev'
import pkg from '../package.json';

export const APP_VERSION = String(import.meta.env.VITE_BUILD_VERSION || pkg?.version || 'dev');
export const BUILD_INFO = {
  version: APP_VERSION,
  // Not strictly build-time, but useful context in dev if VITE_BUILD_TIME is not provided
  time: String(import.meta.env.VITE_BUILD_TIME || ''),
};

